const system_limit = {
    limit_exceeded: "Hai raggiunto il limite di sistema. Contatta l'assistenza per ricevere aiuto.",
};
export default Object.freeze(system_limit);
